import { type ComponentsOverrides, type Theme } from '@mui/material/styles'
import { rem } from 'polished'

import { RADIUS_1 } from '@Styles/constants/radius'

export const overridesTooltip = (theme: Theme): ComponentsOverrides['MuiTooltip'] => ({
  arrow: {
    color: theme.palette.text.secondary,
    fontSize: rem(24),
    width: rem(24),
    '&::before': {
      backgroundColor: theme.customPalette.background.paper,
      border: 0,
    },
  },
  tooltip: {
    backgroundColor: theme.customPalette.background.paper,
    border: 0,
    borderRadius: RADIUS_1,
    color: theme.palette.text.primary,
    padding: 0,
    pointerEvents: 'all',
  },
  tooltipPlacementTop: {
    margin: theme.spacing(2, '0'),
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(2, '0'),
    },
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(2, '0'),
    },
    [theme.breakpoints.up('lg')]: {
      margin: theme.spacing(2, '0'),
    },
    [theme.breakpoints.up('xl')]: {
      margin: theme.spacing(2, '0'),
    },
  },
  tooltipPlacementBottom: {
    margin: `${theme.spacing(1)} 0 0 ${rem(-3)}`,
    [theme.breakpoints.up('sm')]: {
      margin: `${theme.spacing(1)} 0 0 ${rem(-3)}`,
    },
    [theme.breakpoints.up('md')]: {
      margin: `${theme.spacing(1)} 0 0 ${rem(-3)}`,
    },
    [theme.breakpoints.up('lg')]: {
      margin: `${theme.spacing(1)} 0 0 ${rem(-3)}`,
    },
    [theme.breakpoints.up('xl')]: {
      margin: `${theme.spacing(1)} 0 0 ${rem(-3)}`,
    },
  },
})
